import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';

import {NAVER_CALLBACK_SIGN, NAVER_CALLBACK_URL, NAVER_CLIENT_ID} from "../../defines/protocol";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";

const OBJECT_TO_STRING_RE = /^\[object [A-Za-z]+\]$/;


@Component({
  selector: 'app-naver-login-popup',
  styleUrls: ['./naver-login-popup.component.scss'],
  template: `
    <article class="popup">

      <div class="popup-wrapper">

        <article class="popup-msg-form">
          <div class="head-box">책갈피와 네이버 아이디 연동</div>

          <div class="body-box">아래 네이버 버튼을 누르면 네이버 로그인 창이 뜹니다.<br />한국어 베풂은 개인 정보를 수집하지 않습니다.</div>

        </article>

        <div class="popup-foot-box">
          <div id="naver_id_login"
               class="popup-foot-btn"></div>

          <a class="popup-foot-btn type-3"
             (click)="onClickBtn($event)">취소</a>
        </div>

      </div>
    </article>
  `,
})
export class NaverLoginPopupComponent implements OnInit, OnDestroy {

  private boundReceiveMessage = this.receiveMessage.bind(this);

  constructor(
    private lm: LayoutMgrService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngOnInit(): void {
    this.initNaverLogin();

    window.addEventListener('message', this.boundReceiveMessage, false);
  }

  ngOnDestroy(): void {
    // 팝업이 닫혀도 listener가 window에 남아 있으면 이후 popup 인스턴스의
    // naverLoginPopup$ Subject까지 침범해 다른 로그인 시도를 silent하게
    // 중단시킬 수 있다. bound reference로 정확히 같은 함수를 제거한다.
    window.removeEventListener('message', this.boundReceiveMessage, false);
  }

  private initNaverLogin() {
    const naverLoginInstance = new naver_id_login(NAVER_CLIENT_ID, NAVER_CALLBACK_URL);
    const state = naverLoginInstance.getUniqState();
    naverLoginInstance.setButton("green", 2,50);
    naverLoginInstance.setDomain("http://localhost:4200");
    naverLoginInstance.setState(state); // 넣기는 하지만 사용하지 않음.
    naverLoginInstance.setPopup(); // 설졍하면 팝업창이 열리면서 로그인 한다.
    naverLoginInstance.init_naver_id_login();
  }

  receiveMessage(event: MessageEvent) {
    // NAVER_CALLBACK_SIGN은 번들에 그대로 노출되므로 in-band sentinel만으로는
    // postMessage spoofing을 막을 수 없다. 콜백 페이지는 항상 앱과 같은 origin
    // 으로 열리므로 event.origin이 현재 window.location.origin과 일치하는지를
    // 1차 방어로 검사한다.
    if (event.origin !== window.location.origin) {
      return;
    }

    const data = event.data;
    if (data?.sign !== NAVER_CALLBACK_SIGN) {
      return;
    }

    // OpenNaverLoginPopup의 finalize에서 Subject가 null이 된 뒤 ngOnDestroy
    // 전에 다른 message가 도착하면 ?. 단락으로 silent하게 무시된다. 페이로드와
    // 함께 경고를 남겨 duplicate post/SDK 재시도 등의 진단 단서를 보존한다.
    if (!this.lm.naverLoginPopup$) {
      console.warn('NaverLoginPopupComponent::receiveMessage() Subject already null; discarding payload', data);
      return;
    }

    if (!this.isValidNaverKey(data.naverKey)) {
      console.warn('NaverLoginPopupComponent::receiveMessage() invalid naverKey =', data.naverKey);
      // null은 사용자 취소 경로로 예약돼 있다. 비정상 페이로드는 빈 문자열로 전달해
      // SnsService.isValidNaverKey의 invalid 분기에서 에러 안내가 일어나도록 한다.
      this.lm.naverLoginPopup$.next('');
      this.lm.naverLoginPopup$.complete();
      return;
    }

    this.lm.naverLoginPopup$.next(data.naverKey.trim());
    this.lm.naverLoginPopup$.complete();
  }

  private isValidNaverKey(value: unknown): value is string {
    if (typeof value !== 'string') {
      return false;
    }
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return false;
    }
    return !OBJECT_TO_STRING_RE.test(trimmed);
  }

  protected onClickBtn(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);

    if (!this.lm.naverLoginPopup$) {
      throw new Error('NaverLoginPopupComponent.onClickBtn: this.lm.msgPopup$ is undefined');
    }
    this.lm.naverLoginPopup$.next(null);
    this.lm.naverLoginPopup$.complete();
  }
}
